const heroClasses =
    'rounded-2xl p-7 text-white shadow-brand-card bg-primary';

const topRowClasses = 'flex flex-wrap items-start justify-between gap-4';

const titleClasses = "font-serif text-hero-title m-0 mt-1 text-white!";

const FutureCarePreviewHero = () => (
    <div className={heroClasses}>
        <div className={topRowClasses}>
            <div className="min-w-0">
                <h1 className={titleClasses}>Preview Preliminary Lifecare Plan</h1>
            </div>
        </div>
    </div>
);

export default FutureCarePreviewHero;
